import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appLoadMoreOnView]',
  standalone: true
})
export class LoadMoreOnViewDirective implements AfterViewInit, OnDestroy, OnChanges {
  @Input() loadMoreRoot?: HTMLElement | null;
  @Input() loadMoreRootMargin: string = '200px';
  @Input() loadMoreThreshold: number | number[] = 0.1;
  @Input() loadMoreOnce: boolean = false;
  @Input() loadMoreEnabled: boolean = true;

  @Output() loadMore = new EventEmitter<void>();

  private observer?: IntersectionObserver;

  constructor(
    private el: ElementRef<HTMLElement>,
  ) {}

  ngAfterViewInit(): void {
    if (!this.loadMoreEnabled) {
      return;
    }
    // Descobre root se não for informado: usa ancestral rolável do host
    const root = this.loadMoreRoot ?? this.findScrollParent(this.el.nativeElement);

    // A emissão do @Output dispara a detecção de mudança via o listener de
    // template (loadMore) — não é necessário reentrar via NgZone sob zoneless.
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.loadMore.emit();
            if (this.loadMoreOnce) {
              this.observer?.unobserve(this.el.nativeElement);
            }
          }
        }
      },
      {
        root: root || null,
        rootMargin: this.loadMoreRootMargin,
        threshold: this.loadMoreThreshold,
      }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.el?.nativeElement) return;
    if (changes['loadMoreEnabled'] && !changes['loadMoreEnabled'].firstChange) {
      if (this.loadMoreEnabled) {
        // Recria o observer quando for reabilitado
        this.ngAfterViewInit();
      } else {
        this.observer?.disconnect();
        this.observer = undefined;
      }
    }
  }

  private findScrollParent(node: HTMLElement | null): HTMLElement | null {
    let el: HTMLElement | null = node?.parentElement || null;
    while (el) {
      const style = getComputedStyle(el);
      const overflowY = style.overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }
}
